<template>
  <div class="page-content prose">
    <div class="container">
      <div class="flex justify-center pb-8">
        <ContentInfoLinks />
      </div>

      <h1>Tuinbestrating</h1>

      <h2>Tuinbestrating vormt de basis van uw tuin</h2>
      <p>
        Moet uw tuin (opnieuw) bestraat worden? Maar vindt u het lastig de
        juiste steen in de juiste kleur met een mooie structuur en goede
        afmeting te kiezen? HovenierVergelijker.nl helpt u alvast op weg zodat u
        goed geïnformeerd bent voordat u gratis offertes aanvraagt. Wanneer u de
        tuin helemaal opnieuw aanlegt begint u bij de bestrating. Pas hierna
        kunt u aan de slag met bomen, bloemen en accessoires. Omdat de
        tuinbestrating de basis vormt van uw nieuwe tuin is het belangrijk dat
        deze zorgvuldig gekozen en aangelegd wordt. Om die reden is het
        belangrijk dit door een professionele hovenier te laten doen.
      </p>

      <h2>Verharding of halfverharding</h2>
      <p>
        Wanneer u in gesprek gaat met de hovenier zal hij vragen of u kiest voor
        totale verharding of halfverharding. Maar wat bedoelt hij hier nou mee?
        Wanneer het over verharding gaat worden vaak betontegels gebruikt. Deze
        zijn in allerlei kleuren en maten verkrijgbaar. Maar tegenwoordig is
        halfverharding in opkomst. Hiervoor worden meestal materialen gebruikt
        die water beter doorlaten, materialen zoals schelpen, natuursteensplit,
        grind of leemachtige producten.
      </p>

      <h2>Voordelen halfverharding</h2>
      <p>
        Omdat het niet geluidloos is wanneer iemand er overheen loopt wordt u
        gewaarschuwd wanneer u (onverwacht) bezoek krijgt.
      </p>

      <ul class="mb-4">
        <li>Water kan makkelijker weglopen.</li>
        <li>Makkelijk in onderhoud.</li>
        <li>Prijstechnisch vaak goedkoper.</li>
      </ul>

      <h2>Nadelen halfverharding</h2>
      <p>
        Fiets of auto kunnen sporen achterlaten. Kleine materialen (zoals
        steentjes of schelpjes) blijven niet altijd netjes op hun plaats liggen.
        Gevallen bladeren zijn moeilijker op te vegen.
      </p>

      <h2>Tips en ideeën</h2>
      <p>
        Niet alleen met bomen, bloemen en accessoires bepaalt u de sfeer van uw
        tuin. De tuinbestrating speelt hierbij een belangrijke rol. Met name in
        de winter, wanneer de tuinmeubelen opgeborgen worden en de bloemen niet
        meer in bloei staan. Afhankelijk van de sfeer die uw tuin moet
        uitstralen kiest u voor een bepaald materiaal. Turks marmer bijvoorbeeld
        creëert een mediterrane sfeer en houten tuintegels geven u een western
        sfeer. Maar u hoeft natuurlijk niet voor één en dezelfde steen te
        kiezen. Zo is het vaak erg mooi wanneer u één steensoort kiest in
        diverse afmetingen en kleuren. Dit creëert een vrolijk en afwisselend
        geheel. Overigens kunt u diverse materialen best met elkaar combineren.
        Ook is er een enorm aanbod aan sierbestrating voor uw terras.
        HovenierVergelijker.nl wilt u graag attenderen op de te kiezen kleuren.
        In de tuin is een witte tegel erg opvallend en trekt vaak alle aandacht
        naar zich toe. Houd hier rekening mee wanneer u plannen heeft voor het
        leggen van tegels. Want u wilt toch niet dat uw terrastegels meer
        aandacht trekken dan het meubilair en de prachtige natuur in uw tuin?
        Natuurlijk kan de hovenier u hier meer informatie over geven.
      </p>

      <p>
        Bezoek voor inspiratie eens andere tuinen. Dit helpt u wellicht een goed
        beeld te vormen van de wensen voor uw eigen tuin. Via
        HovenierVergelijker.nl kunt u gratis offertes aanvragen bij de
        aangesloten hoveniers uit uw regio.
      </p>
    </div>
  </div>
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'
import ContentInfoLinks from '~/components/layout/ContentInfoLinks'

export default {
  components: {
    ContentInfoLinks,
  },

  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      title: 'Je tuin laten bestraten met 40% korting?',
      description:
        'Moet uw tuin (opnieuw) bestraat worden? Maar vindt u het lastig de juiste steen in de juiste kleur met een mooie structuur en goede afmeting te kiezen?',
    }
  },
}
</script>
